import { Grid, makeStyles } from '@material-ui/core'
import { Certificate } from 'crypto'
import { FC } from 'react'
import { Form } from 'react-final-form'
import MyTextfield from '../../../control/textfield/textfield'
import useTranslate from '../../../i18n/useTranslate'
import { CertificateFormProps } from '../../../pages/SettingCertificate'
interface OfficerProps {}
const Officer: FC<OfficerProps> = ({}) => {
    const classes = useStyles()
    const translate = useTranslate()
    return (
        <Grid container spacing={2} className={classes.container}>
            <Grid item xs={12} className={classes.item}>
                <MyTextfield
                    name="detail_TH"
                    materialInputProps={{
                        label: translate.get('UM.SETTINGCERTIFICATE.DETAIL_TH'),
                        disabled: false,
                        placeholder: translate.get('UM.SETTINGCERTIFICATE.DETAIL_TH'),
                        size: 'medium',
                        rows: 5,
                        multiline: true,
                    }}
                    required
                />
            </Grid>
            <Grid item xs={12} className={classes.item}>
                <MyTextfield
                    name="detail_EN"
                    materialInputProps={{
                        label: translate.get('UM.SETTINGCERTIFICATE.DETAIL_EN'),
                        disabled: false,
                        placeholder: translate.get('UM.SETTINGCERTIFICATE.DETAIL_EN'),
                        size: 'medium',
                        rows: 5,
                        multiline: true,
                    }}
                    required
                />
            </Grid>
            <Grid item xs={12} className={classes.item}>
                <MyTextfield
                    name="condition_TH"
                    materialInputProps={{
                        label: translate.get('UM.SETTINGCERTIFICATE.CONDITION_TH'),
                        disabled: false,
                        placeholder: translate.get('UM.SETTINGCERTIFICATE.CONDITION_TH'),
                        size: 'medium',
                        rows: 5,
                        multiline: true,
                    }}
                    required
                />
            </Grid>
            <Grid item xs={12} className={classes.item}>
                <MyTextfield
                    name="condition_EN"
                    materialInputProps={{
                        label: translate.get('UM.SETTINGCERTIFICATE.CONDITION_EN'),
                        disabled: false,
                        placeholder: translate.get('UM.SETTINGCERTIFICATE.CONDITION_EN'),
                        size: 'medium',
                        rows: 5,
                        multiline: true,
                    }}
                    required
                />
            </Grid>

            <Grid item xs={12} className={classes.item}>
                <MyTextfield
                    name="detail_exempt_TH"
                    materialInputProps={{
                        label: translate.get('UM.SETTINGCERTIFICATE.DETAIL_EXEMPT_TH'),
                        disabled: false,
                        placeholder: translate.get('UM.SETTINGCERTIFICATE.DETAIL_EXEMPT_TH'),
                        size: 'medium',
                        rows: 5,
                        multiline: true,
                    }}
                    // required
                />
            </Grid>
            <Grid item xs={12} className={classes.item}>
                <MyTextfield
                    name="detail_exempt_EN"
                    materialInputProps={{
                        label: translate.get('UM.SETTINGCERTIFICATE.DETAIL_EXEMPT_EN'),
                        disabled: false,
                        placeholder: translate.get('UM.SETTINGCERTIFICATE.DETAIL_EXEMPT_EN'),
                        size: 'medium',
                        rows: 5,
                        multiline: true,
                    }}
                    // required
                />
            </Grid>
            <Grid item xs={12} className={classes.item}>
                <MyTextfield
                    name="condition_exempt_TH"
                    materialInputProps={{
                        label: translate.get('UM.SETTINGCERTIFICATE.CONDITION_EXEMPT_TH'),
                        disabled: false,
                        placeholder: translate.get('UM.SETTINGCERTIFICATE.CONDITION_EXEMPT_TH'),
                        size: 'medium',
                        rows: 5,
                        multiline: true,
                    }}
                    // required
                />
            </Grid>
            <Grid item xs={12} className={classes.item}>
                <MyTextfield
                    name="condition_exempt_EN"
                    materialInputProps={{
                        label: translate.get('UM.SETTINGCERTIFICATE.CONDITION_EXEMPT_EN'),
                        disabled: false,
                        placeholder: translate.get('UM.SETTINGCERTIFICATE.CONDITION_EXEMPT_EN'),
                        size: 'medium',
                        rows: 5,
                        multiline: true,
                    }}
                    // required
                />
            </Grid>
        </Grid>
    )
}

export default Officer

const useStyles = makeStyles(() => ({
    container: {
        padding: '1.7rem',
    },
    item: {
        marginBottom: '1rem',
    },
}))
